// src/components/manager-v2/flows/TeamFlowAutomation.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GitBranch, Zap } from 'lucide-react';
import { FlowAutomationProvider } from '../../../contexts/FlowAutomationContext';
import { useTheme } from '../../../contexts/ThemeContext';
import TeamWorkflowList from './TeamWorkflowList';
import TeamAutomationRules from './TeamAutomationRules';

const TABS = [
    { key: 'workflows', label: 'Team Workflows', icon: GitBranch },
    { key: 'automations', label: 'Quick Rules', icon: Zap },
];

const TeamFlowAutomation = () => {
    const { theme } = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const isDark = theme === 'dark';
    const [activeTab, setActiveTab] = useState('workflows');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tab = params.get('tab');
        if (tab && TABS.some(t => t.key === tab)) {
            setActiveTab(tab);
        }
    }, [location.search]);

    const handleTabChange = (tabKey) => {
        setActiveTab(tabKey);
        navigate(`/manager/flows?tab=${tabKey}`, { replace: true });
    };

    return (
        <FlowAutomationProvider>
            <div className="space-y-6">
                <div>
                    <h1 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                        Team Automations
                    </h1>
                    <p className={`mt-1 text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                        Manage workflow automations for your team
                    </p>
                </div>

                {/* Tabs */}
                <div className={`border-b ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
                    <nav className="-mb-px flex space-x-6">
                        {TABS.map((tab) => {
                            const Icon = tab.icon;
                            const isActive = activeTab === tab.key;
                            return (
                                <button
                                    key={tab.key}
                                    onClick={() => handleTabChange(tab.key)}
                                    className={`flex items-center gap-2 border-b-2 py-3 px-1 text-sm font-medium transition-colors ${
                                        isActive
                                            ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                                            : `border-transparent ${isDark ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700'}`
                                    }`}
                                >
                                    <Icon className="w-4 h-4" />
                                    {tab.label}
                                </button>
                            );
                        })}
                    </nav>
                </div>

                {activeTab === 'workflows' ? <TeamWorkflowList /> : <TeamAutomationRules />}
            </div>
        </FlowAutomationProvider>
    );
};

export default TeamFlowAutomation;
